import Equipment from '../../models/Equipment';
import { ROUTES } from '../../../../config/routes';
import translations from './locales';

const xd10ii = new Equipment({
  id: 'xd10ii',
  name: 'XD10II',
  specificationsAnchor: 'xd-specs',
  displayName: { main: 'XD10', accent: 'II' },
  path: ROUTES.xd10iiIntro,
  assetDirectory: '/Equipment/xd10ii',
  translations,
  image: { file: 'machine.png', width: 1254, height: 1254 },
  video: { file: 'introduction.mp4', poster: 'video-poster.jpg' },
  catalog: {
    fallbackLanguage: 'en',
    files: { ko: 'catalog.png', en: 'catalog-en.png', zh: 'catalog-zh.png' },
  },
  badges: [
    { id: 'diameter', valueKey: 'diameterTag' },
    { id: 'spindle', value: '15,000 rpm' },
  ],
  metrics: [
    { id: 'diameter', labelKey: 'specifications.maxDiameter.label', value: 'Ø10', unit: 'mm' },
    { id: 'spindle', labelKey: 'specifications.mainSpindle.label', value: '15,000', unit: 'rpm' },
    { id: 'stroke', labelKey: 'specifications.z1Stroke.label', value: '155', unit: 'mm' },
    { id: 'axes', commonLabelKey: 'axisConfig', value: '5/6', commonUnitKey: 'axes' },
  ],
  features: ['compact', 'mainSpindle', 'backTools'],
  specifications: [
    { id: 'nc', value: 'Fanuc 0i TF Plus' },
    { id: 'maxDiameter', value: 'Ø10 mm' },
    { id: 'z1Stroke', value: '155 mm' },
    { id: 'mainSpindle', value: '15,000 rpm · 2.2 / 3.7 kW' },
    { id: 'turningTools', value: '6 × (□8 mm)' },
    { id: 'frontTools', value: '5 × (ER11)' },
    { id: 'crossTools' },
    { id: 'crossSpeed', value: '10,000 rpm / 0.55 kW' },
    { id: 'subSpindle', value: '10,000 rpm · 0.55 / 1.1 kW' },
    { id: 'backTools' },
    { id: 'backSpeed', value: '9,000 rpm / 0.55 kW' },
    { id: 'dimensions', value: '1,810 × 900 × 1,770 mm' },
    { id: 'weight', value: '1,950 kg' },
    { id: 'power' },
    { id: 'air', value: '120–150 L/min' },
  ],
  specificationNoteKey: 'powerNote',
  options: ['whirling', 'cross', 'y2BackTools', 'backTools'],
  optionImages: {
    whirling: 'whirling.jpg',
    cross: 'cross.jpg',
    y2BackTools: 'y2BackTools.jpg',
    backTools: 'backTools.jpg',
  },
});

export default xd10ii;
